<template>
  <div class="result" v-bind:class="[isSpecialCard ? 'specialRace' : '', isWin ? 'win' : 'lose']">
    <vue-audio :file="10" ref="resultWin"></vue-audio>
    <vue-audio :file="11" ref="resultLose"></vue-audio>
    <vue-audio :file="3" ref="btnClick"></vue-audio>
    <ul class="result__list">
      <li :class="colorHorse"></li>
      <li class="result__item">
        <!--<p class="result__message">{{ updateMessage }}</p>-->
        <p class="result__message" :class="result" v-if="isWin">
          <img src="../assets/image/txt_win.png" alt="you win" >
        </p>
        <p class="result__message" :class="result" v-else>
          <img src="../assets/image/txt_lose.png" alt="you-lose">
        </p>
        <ul class="result__list--sm">
          <li class="result__row" v-show="!isSpecialCard">
            <button class="result__button" @click="showModal('specialCard')"><span><img src="../assets/image/txt_result_crispr.png" alt="ゲノムカード１枚をCRISPR-CASカードに変えてもう一度やる"></span></button>
            <p><button @click="showModal('specialCardInfo')"><!--CRISPR-CAS カードとは？--> <img src="../assets/image/txt_result_crispr_info.png" alt="CRISPR-CAS カードとは"></button></p>
          </li>
          <li class="result__row">
            <button class="result__button" @click="showModal('race')"><span><img src="../assets/image/txt_result_race.png" alt="同じゲノムカードでもう一度やる"></span></button>
          </li>
          <li class="result__row">
            <button class="result__button" @click="showModal('card')"><span><img src="../assets/image/txt_result_card.png" alt="最初からやる"></span></button>
          </li>
          <li class="result__row">
            <button class="result__button" @click="showModal('close')"><span><img src="../assets/image/txt_result_close.png" alt="終わる"></span></button>
          </li>
        </ul>
      </li>
    </ul>
    <modal :id="key" :show.sync="isModal" :type="typeName"></modal>
  </div>
</template>
<script>
  import { store } from '../store/store'
  import Modal from './Modal'
  import Audio from './Audio'
  import _ from 'lodash'
  export default {
    name: 'Result',
    data () {
      return {
        message: {
          win: 'YOU WIN!',
          lose: 'YOU LOSE'
        },
        result: '',
        key: '',
        isModal: false,
        typeName: ''
      }
    },
    computed: {
      colorHorse () {
        return 'result__item horse-0' + store.state.horseUser.color
      },
      updateMessage () {
        this.result = store.state.isWin ? 'win' : 'lose'
        return this.message[this.result]
      },
      isSpecialCard () {
        return store.state.replaySpecialcard
      },
      isWin () {
        return store.state.isWin
      }
    },
    components: {
      'modal': Modal,
      'vue-audio': Audio
    },
    methods: {
      showModal (key) {
        // Play audio button click
        this.$refs.btnClick.play()
        // Set data for modal
        this.key = key
        this.typeName = _.includes(['specialCard', 'race', 'card', 'close'], this.key) ? 'confirm' : 'alert'
        return (this.isModal = true)
      }
    },
    mounted () {
      store.state.isWin ? this.$refs.resultWin.play() : this.$refs.resultLose.play()
    }
  }
</script>



// WEBPACK FOOTER //
// Result.vue?53194d03